import * as React from 'react'
import classNames from 'classnames'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { SVG_Forward } from '../svg/SVG_Forward'
import { SVG_Section } from '../svg/SVG_Section'
import { SVG_Tick } from '../svg/SVG_Tick'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementValidation } from './ElementValidation'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import i18next from 'i18next'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    required: boolean
    answerValue: Flows.SectionAnswer['value']
    validationMessages: string[]
    routeToSection: (sectionId: Flows.ElementId, loopPathId: LoopPathIds) => void
    isInProgress: boolean
}

export class ElementSection extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const { elementId, label, required, validationMessages, routeToSection } = this.props

        const isCompleted = this.props.answerValue === 'completed'

        return (
            <ExecutionElement
                deps={this.props.deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={validationMessages}
            >
                <div className="AppCore__flow__ElementSection__validation">
                    <ElementValidation validationMessages={validationMessages} />
                </div>
                <div
                    className={classNames('AppCore__flow__ElementSection', { isCompleted })}
                    onClick={() => routeToSection(elementId, this.props.loopPathIds)}
                >
                    <div className="AppCore__flow__ElementSection__icon">
                        <SVG_Section />
                    </div>

                    <div className="AppCore__flow__ElementSection__label-column">
                        <div className="AppCore__flow__ElementSection__label">
                            {required && <div className="AppCore__flow__ExecutionLabel__icon"> * </div>}
                            {label}
                        </div>
                        {isCompleted && (
                            <div className="AppCore__flow__ElementSection__completedLabel">
                                {i18next.t('appcore:element.section.completed')}
                            </div>
                        )}
                        {this.props.isInProgress && (
                            <div className="AppCore__flow__ElementSection__inProgressLabel">
                                {i18next.t('appcore:element.section.inProgress')}
                            </div>
                        )}
                    </div>

                    {!isCompleted && (
                        <div className="AppCore__flow__ElementSection__forward">
                            <SVG_Forward />
                        </div>
                    )}
                    {isCompleted && (
                        <div className="AppCore__flow__ElementSection__tick">
                            <SVG_Tick color="var(--white)" />
                        </div>
                    )}
                </div>
            </ExecutionElement>
        )
    }
}
